import { createStructuredSelector, createSelector } from "reselect";

export const faqModalOpenSelector = state =>
  state.ctd.getIn(["download", "faqModalOpen"]);
export const castDistChartModalOpenSelector = state =>
  state.ctd.getIn(["download", "castDistChartModalOpen"]);
export const previewFileDialogOpenSelector = state =>
  state.ctd.getIn(["download", "previewFileDialogOpen"]);
export const previewFileTitleSelector = state =>
  state.ctd.getIn(["download", "previewFileTitle"]);
export const previewFileBodySelector = state =>
  state.ctd.getIn(["download", "previewFileBody"]);
export const isFetchingSelector = state =>
  state.ctd.getIn(["download", "isFetching"]);
export const surveyStationOptionsIsFetchingSelector = state =>
  state.ctd.getIn(["download", "surveyStationOptionsIsFetching"]);
export const startDateFilterSelector = state =>
  state.ctd.getIn(["download", "startDateFilter"]);
export const endDateFilterSelector = state =>
  state.ctd.getIn(["download", "endDateFilter"]);
export const downloadTypeSelector = state =>
  state.ctd.getIn(["download", "downloadType"]);
export const processingStageFilterSelector = state =>
  state.ctd.getIn(["download", "processingStageFilter"]);
export const instrumentFilterSelector = state =>
  state.ctd.getIn(["download", "instrumentFilter"]);
export const instrumentFilterOverrideSelector = state =>
  state.ctd.getIn(["download", "instrumentFilterOverride"]);
export const serialNumFilterSelector = state =>
  state.ctd.getIn(["download", "serialNumFilter"]);
export const bufferFilterSelector = state =>
  state.ctd.getIn(["download", "bufferFilter"]);
export const upcastFilterSelector = state =>
  state.ctd.getIn(["download", "upcastFilter"]);
export const totalCastsWithFiltersSelector = state =>
  state.ctd.getIn(["download", "totalCastsWithFilters"]);
export const zipDownloadIsFetchingSelector = state =>
  state.ctd.getIn(["download", "zipDownloadIsFetching"]);
export const xlsxDownloadIsFetchingSelector = state =>
  state.ctd.getIn(["download", "xlsxDownloadIsFetching"]);
export const csvDownloadIsFetchingSelector = state =>
  state.ctd.getIn(["download", "csvDownloadIsFetching"]);
export const bulkDownloadIsFetchingSelector = state =>
  state.ctd.getIn(["download", "bulkDownloadIsFetching"]);
export const metadataDownloadIsFetchingSelector = state =>
  state.ctd.getIn(["download", "metadataDownloadIsFetching"]);
export const castDistChartDataIsFetchingSelector = state =>
  state.ctd.getIn(["download", "castDistChartDataIsFetching"]);
export const castDistChartDataSelector = createSelector(
  state => state.ctd.getIn(["download", "castDistChartData"]),
  x => x.toJS()
);
export const brushExtentSelector = createSelector(
  state => state.ctd.getIn(["download", "brushExtent"]),
  x => x.toJS()
);
export const brushedCastDistChartDataSelector = createSelector(
  [castDistChartDataSelector, brushExtentSelector],
  (cdS, beS) => cdS.filter(d => d.time >= beS[0] && d.time <= beS[1])
);

export const brushDidInvalidateSelector = state =>
  state.ctd.getIn(["download", "brushDidInvalidate"]);

export const pageNumberSelector = state =>
  state.ctd.getIn(["download", "page"]);
export const itemsPerPageSelector = state =>
  state.ctd.getIn(["download", "itemsPerPage"]);
export const didInvalidateSelector = state =>
  state.ctd.getIn(["download", "didInvalidate"]);

export const allCastsSelector = createSelector(
  state => state.ctd.getIn(["download", "casts"]),
  f => f.toJS()
);

export const castsOffsetSelector = createSelector(
  [pageNumberSelector, itemsPerPageSelector],
  (pN, iPP) => (pN - 1) * iPP
);

export const castsLimitSelector = createSelector(
  [pageNumberSelector, itemsPerPageSelector],
  (pN, iPP) => pN * iPP
);

export const castsOnPageSelector = createSelector(
  [allCastsSelector, castsOffsetSelector, castsLimitSelector],
  (aF, fO, fL) => aF.slice(fO, fL)
);

export const workareaFilterSelector = createSelector(
  state => state.ctd.getIn(["download", "workareaFilter"]),
  f => f.toJS()
);

export const organizationFilterSelector = createSelector(
  state => state.ctd.getIn(["download", "organizationFilter"]),
  f => f.toJS()
);

export const surveyFilterSelector = createSelector(
  state => state.ctd.getIn(["download", "surveyFilter"]),
  f => f.toJS()
);

export const filenameFilterSelector = createSelector(
  state => state.ctd.getIn(["download", "filenameFilter"]),
  f => f.toJS()
);

export const castPkFilterSelector = createSelector(
  state => state.ctd.getIn(["download", "castPkFilter"]),
  f => f.toJS()
);

export const hakaiIdFilterSelector = createSelector(
  state => state.ctd.getIn(["download", "hakaiIdFilter"]),
  f => f.toJS()
);

export const stationFilterSelector = createSelector(
  state => state.ctd.getIn(["download", "stationFilter"]),
  f => f.toJS()
);

export const surveyStationOptionsSelector = state =>
  state.ctd.getIn(["download", "surveyStationOptions"]);

export const deviceModelSelector = createSelector(
  state => state.ctd.getIn(["download", "deviceModels"]),
  f => f.toJS()
);
export const deviceSnSelector = createSelector(
  state => state.ctd.getIn(["download", "deviceSn"]),
  f => f.toJS()
);

export const workareaSurveyStationOptionsSelector = createSelector(
  [surveyStationOptionsSelector, workareaFilterSelector],
  // if workarea is set to "any", provide all the surveys and stations as options
  (sSO, w) => sSO.filter(x => w.length === 0 || w.includes(x.get("work_area")))
);

export const workareaOptionsSelector = createSelector(
  [surveyStationOptionsSelector],
  sSO =>
    sSO
      .map(x => x.get("work_area"))
      .sort()
      .toOrderedSet()
      .toJS()
);

export const organizationOptionsSelector = createSelector(
  [surveyStationOptionsSelector, workareaFilterSelector],
  (sSO, w) =>
    sSO
      .filter(x => w.length === 0 || w.includes(x.get("work_area")))
      .map(x => x.get("organization"))
      .sort()
      .toOrderedSet()
      .toJS()
);

export const surveyOptionsSelector = createSelector(
  [workareaSurveyStationOptionsSelector],
  wSSO =>
    wSSO
      .map(x => x.get("cruise"))
      .sort()
      .toOrderedSet()
      .toJS()
);

export const stationOptionsSelector = createSelector(
  [workareaSurveyStationOptionsSelector, surveyFilterSelector],
  (wSSO, sF) =>
    wSSO
      .filter(x => sF.length === 0 || sF.includes(x.get("cruise")))
      .map(x => x.get("station"))
      .sort()
      .toOrderedSet()
      .toJS()
);

export default createStructuredSelector({
  casts: castsOnPageSelector,
  castsLimit: castsLimitSelector,
  castsOffset: castsOffsetSelector,
  faqModalOpen: faqModalOpenSelector,
  castDistChartModalOpen: castDistChartModalOpenSelector,
  previewFileDialogOpen: previewFileDialogOpenSelector,
  previewFileTitle: previewFileTitleSelector,
  previewFileBody: previewFileBodySelector,
  isFetching: isFetchingSelector,
  surveyStationOptionsIsFetching: surveyStationOptionsIsFetchingSelector,
  pageNumber: pageNumberSelector,
  itemsPerPage: itemsPerPageSelector,
  workareaOptions: workareaOptionsSelector,
  organizationOptions: organizationOptionsSelector,
  surveyOptions: surveyOptionsSelector,
  stationOptions: stationOptionsSelector,
  surveyFilter: surveyFilterSelector,
  stationFilter: stationFilterSelector,
  startDateFilter: startDateFilterSelector,
  endDateFilter: endDateFilterSelector,
  downloadType: downloadTypeSelector,
  processingStageFilter: processingStageFilterSelector,
  instrumentFilter: instrumentFilterSelector,
  instrumentFilterOverride: instrumentFilterOverrideSelector,
  serialNumFilter: serialNumFilterSelector,
  workareaFilter: workareaFilterSelector,
  organizationFilter: organizationFilterSelector,
  bufferFilter: bufferFilterSelector,
  upcastFilter: upcastFilterSelector,
  filenameFilter: filenameFilterSelector,
  castPkFilter: castPkFilterSelector,
  hakaiIdFilter: hakaiIdFilterSelector,
  totalCastsWithFilters: totalCastsWithFiltersSelector,
  zipDownloadIsFetching: zipDownloadIsFetchingSelector,
  xlsxDownloadIsFetching: xlsxDownloadIsFetchingSelector,
  csvDownloadIsFetching: csvDownloadIsFetchingSelector,
  bulkDownloadIsFetching: bulkDownloadIsFetchingSelector,
  metadataDownloadIsFetching: metadataDownloadIsFetchingSelector,
  castDistChartDataIsFetching: castDistChartDataIsFetchingSelector,
  castDistChartData: castDistChartDataSelector,
  brushExtent: brushExtentSelector,
  brushedCastDistChartData: brushedCastDistChartDataSelector,
  brushDidInvalidate: brushDidInvalidateSelector,
  didInvalidate: didInvalidateSelector,
  deviceModels: deviceModelSelector,
  deviceSn: deviceSnSelector
});
